import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { BoardCover } from "~/components/v2/components/board/board-cover/BoardCover";
export const PublicBoardCover = /*#__PURE__*/ memo((param)=>{
    let { board } = param;
    var _board_coverImage;
    // For public boards, we need to check if the cover image actually belongs to this board
    // The API returns inherited cover images for subboards, so we need to detect if it's inherited
    const hasAncestors = board.ancestors && board.ancestors.length > 0;
    // If no cover image, don't show anything
    if (!board.coverImage) {
        return null;
    }
    // For top-level boards (no ancestors), always show the cover
    if (!hasAncestors) {
        return /*#__PURE__*/ _jsx("div", {
            className: "px-4",
            children: /*#__PURE__*/ _jsx(BoardCover, {
                board: board
            })
        });
    }
    // For subboards, check if the cover image's clipId belongs to this board's assets
    // This is a more accurate way to detect if the cover is owned vs inherited
    const coverClipId = (_board_coverImage = board.coverImage) === null || _board_coverImage === void 0 ? void 0 : _board_coverImage.clipId;
    // If we have a cover image with a clipId, check if it belongs to this board
    if (coverClipId) {
        var _board_thumbnails;
        // Check if the clipId is in the board's thumbnails (which represent the board's assets)
        // thumbnails are URLs, so we need to extract the clipId from them
        const thumbnailClipIds = (_board_thumbnails = board.thumbnails) === null || _board_thumbnails === void 0 ? void 0 : _board_thumbnails.map((thumbnail)=>{
            // Extract clipId from URL like 'https://air-dev.imgix.net/2e158187-fff6-45b2-97da-8cd0f4c158aa.jpg'
            const match = thumbnail.match(/\/([a-f0-9-]+)\./);
            return match ? match[1] : null;
        }).filter(Boolean);
        const hasOwnCover = thumbnailClipIds === null || thumbnailClipIds === void 0 ? void 0 : thumbnailClipIds.includes(coverClipId);
        if (!hasOwnCover) {
            // This cover image doesn't belong to this board, so it's inherited
            return null;
        }
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "px-4",
        children: /*#__PURE__*/ _jsx(BoardCover, {
            board: board
        })
    });
});
PublicBoardCover.displayName = "PublicBoardCover";
